import { axiosInstance } from './base'
import axios from 'axios'

export function addCompanies (data) {
  return axiosInstance.post('tech-providers/', data)
}

export function fetchCompanies (query) {
  return axiosInstance.get('tech-providers/' + query)
}

export function fetchCompanyBySlug (slug) {
  return axiosInstance.get(`tech-providers/${slug}`)
}

export function updateCompanyBySlug (slug, data) {
  return axiosInstance.put(`tech-providers/${slug}/`, data)
}

export function getStreetAddress (lat, long) {
  return axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + long + '&key=' + process.env.VUE_APP_GOOGLE_API_KEY)
}

export function fetchCompaniesByCategory (catId, query) {
  let path = `tech-providers/${catId}`
  if (query) path = `tech-providers/${catId}${query}`
  return axiosInstance.get(path)
}
